import { ref } from 'vue';
import { defineStore } from 'pinia';
import { type SnackbarType } from '@/features/snackbar';

const STORAGE_KEY = 'snackbar';

// Snackbarの状態をオブジェクトで保持するための型
type SnackbarPayload = {
  type: SnackbarType;
  message?: string; // 任意のエラーメッセージを格納する
};

export const useSnackbarStore = defineStore('snackbar', () => {
  // セッションストレージから読み取って初期化（初回ロード時）
  const storedValue = sessionStorage.getItem(STORAGE_KEY);
  let initialValue: SnackbarPayload | null = null;
  if (storedValue) {
    try {
      initialValue = JSON.parse(storedValue);
    } catch (e) {
      // JSONパースに失敗した場合は無視
      console.error('Failed to parse snackbar data from sessionStorage', e);
    }
  }

  // current は {type, message} を持つか null
  const current = ref<SnackbarPayload | null>(initialValue);

  /**
   * スナックバーの表示内容をセットする
   * @param type 既存のスナックバー種別 (updated, invalid_file etc)
   * @param message カスタムメッセージ（任意）
   */
  function set(type: SnackbarType, message?: string) {
    // セット時にオブジェクトとしてセッションストレージに保存
    const payload: SnackbarPayload = { type, message };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    current.value = payload;
  }

  /**
   * スナックバーをリセット（閉じる）
   */
  function $reset() {
    sessionStorage.removeItem(STORAGE_KEY);
    current.value = null;
  }

  return { current, set, $reset };
});